import { render, staticRenderFns } from "./ShareHomeLayout.vue?vue&type=template&id=6ad8a9e6&scoped=true"
import script from "./ShareHomeLayout.vue?vue&type=script&lang=ts"
export * from "./ShareHomeLayout.vue?vue&type=script&lang=ts"
import style0 from "./ShareHomeLayout.vue?vue&type=style&index=0&id=6ad8a9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8a9e6",
  null
  
)

export default component.exports